/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The status of a webhook.
 */
export const WebhookStatus = {
  Enabled: "enabled",
  Disabled: "disabled",
} as const;
/**
 * The status of a webhook.
 */
export type WebhookStatus = ClosedEnum<typeof WebhookStatus>;

/** @internal */
export const WebhookStatus$inboundSchema: z.ZodNativeEnum<
  typeof WebhookStatus
> = z.nativeEnum(WebhookStatus);
/** @internal */
export const WebhookStatus$outboundSchema: z.ZodNativeEnum<
  typeof WebhookStatus
> = WebhookStatus$inboundSchema;
